import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './SBack.css';

interface SBackProps {
  onClick?: () => void;
  className?: string;
}

export const SBack: React.FC<SBackProps> = ({ onClick, className }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    const segments = location.pathname.replace(/\/$/, '').split('/').filter(Boolean);
    navigate(segments.length <= 1 ? '/' : '/' + segments.slice(0, -1).join('/'));
  };

  return (
    <button
      className={['s-back-btn', className].filter(Boolean).join(' ')}
      onClick={handleClick}
      aria-label="Go back"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M19 12H5m5-5-5 5 5 5"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default SBack;
